import { Component } from 'react';

import { Box, LinearProgress } from '@mui/material';
import { inject, observer } from 'mobx-react';
import { flowRight as compose } from 'lodash';

import { formatTag } from 'Utils/tag';
import JSearchInput from 'components/JSearchInput';
import MiniStopBox from '../../../../components/MiniStopBox';
import styles from './styles';

class ShipmentList extends Component {
  constructor(props) {
    super(props);
  }

  selectStop = (stop) => {
    this.props?.onSelectStop?.(stop);
  };

  changeSearch = (v) => {
    const { assignmentStore } = this.props.store;
    assignmentStore.filter = v;
  };

  render() {
    const { store } = this.props;
    const { assignmentStore, shipmentStore } = store;
    const { filteredShowingStops, loadingAssignment } = assignmentStore;
    const { selectedStopId } = shipmentStore;

    if (loadingAssignment) {
      return (
        <Box sx={styles.container}>
          <LinearProgress color="primary" />
        </Box>
      );
    }

    return (
      <Box sx={styles.container}>
        <Box p={1} pb={0}>
          <JSearchInput placeholder="Search Shipment" value={assignmentStore.filter} onChange={this.changeSearch} />
        </Box>
        <Box sx={styles.list}>
          {filteredShowingStops &&
            filteredShowingStops.map((stop) => {
              const tags = stop.shipment?.tags
                ? stop.shipment.tags.map((tag, i) => {
                    return {
                      text: <span style={styles.text}>{formatTag(tag)}</span>,
                      value: i,
                    };
                  })
                : [];
              return (
                <MiniStopBox
                  onClick={() => this.selectStop(stop)}
                  key={stop.id}
                  style={{ opacity: !selectedStopId || selectedStopId === stop.id ? 1.0 : 0.5 }}
                  stop={stop}
                  tags={tags}
                  assignmentStore={assignmentStore}
                />
              );
            })}
        </Box>
      </Box>
    );
  }
}

const ShipmentListCompose = compose(inject('store'), observer)(ShipmentList);

export default ShipmentListCompose;
